import React, { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export const Card = ({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: HTMLAttributes<HTMLDivElement>["className"];
}) => {
  return (
    <div
      className={twMerge(
        "mx-auto flex max-w-container flex-col items-start bg-white lg:shadow-[0px_48px_40px_-8px_rgba(20,20,20,0.12)]",
        className
      )}
    >
      {children}
    </div>
  );
};
